import {html} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import B2bElement from '../../../../b2b-element.js';
import B2bPublicServiceClientProxy from '../../../../gen/com/arabellesolutions/sdc/b2b/pub/B2bPublicServiceClientProxy.js';
import defaultStyle from '../../../b2b-public-styles.scss';

@customElement('b2b-public-linkemail')
export class B2bPublicLinkemail extends B2bElement {
  static styles = [defaultStyle];

  /** @type {String} */
  @state()
  accessor __code;

  @property({type: Object, attribute: false})
  accessor route;

  @state()
  accessor __message;

  __b2bPublicServiceProxy = new B2bPublicServiceClientProxy(super.msgpackClientPublic());

  render() {
    return html`
      <mta-page-lit page-name="linkemail" title="Email Verification"></mta-page-lit>
      <div class="no-account">
        <h1>${this.__message}</h1>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.__code = this.route.args.code;
    this.isValid = this.__b2bPublicServiceProxy.verifyUserByCode(this.__code);

    this.isValid.then(
        () => {
          this.__message = 'Your email has been verified successfully';
          setTimeout(() => {
            this.redirect('#/auth/login');
          }, 3000);
        }).catch(
        () => {
          this.__message = 'Invalid link. Please try to reconnect';
          setTimeout(() => {
            this.redirect('#/auth/registration');
          }, 3000);
        });
  }
}
